module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-roofing.svg?dbe8f39c9945bfbd6c28959bf261a925";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-roofing.svg
// module id = 1046
// module chunks = 1